module.exports = __webpack_public_path__ + "img/messages.6189d596.svg";